import React, {useState, useEffect} from "react";
import {Routes, Route, useNavigate,useLocation,Link,useParams} from 'react-router-dom';
import moment from 'moment';
import {  Table, Select, DatePicker, Spin, Input, Empty, Breadcrumb, Skeleton } from 'antd';
import { ArrowRightOutlined, HomeOutlined, BankFilled } from '@ant-design/icons';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell} from 'recharts';

import * as Styled from './style.js';
import { postData,getData } from '../../config/api-connect';
import Spinner from '../../components/spinner'

const { Option } = Select;
const { TextArea } = Input;

const COLORS = ['#39b351','#0088FE', '#FFBB28', '#FF8042', '#FF6F61', '#6A67CE', '#00C49F'];

const CollectionSummary = () => {
  const navigate = useNavigate();
  const { venue_id,venue_name } = useParams();
  var local_selectedVenueId = venue_id
  var local_selectedVenueName = venue_name
  var local_month = JSON.parse(localStorage.getItem('month'));
  var local_year = JSON.parse(localStorage.getItem('year'));
  var local_city = JSON.parse(localStorage.getItem('cityId'))

  const [loading, setLoading] = useState(true)
  const [graphLoading, setGraphLoading] = useState(false)
  const [selectedVenueId, setSelectedVenueId] = useState(local_selectedVenueId)
  const [collectionDetails, setCollectionDetails] = useState([])
  const [header, setHeader] = useState([])
  const [month, setMonth] = useState(local_month)
  const [year, setYear] = useState(local_year)
  const [venueName, setVenueName] = useState(local_selectedVenueName)
  const [graphData, setGraphData] = useState({})
  const [pieGraphData, setPieGraphData] = useState([])
  const [totalCollection, setTotalCollection] = useState('')
  const [cityId, setCityId] = useState(local_city)
  const [pieLoading,setPieLoading] = useState(false)
  const [totalData, setTotalData] = useState({})

  useEffect(() => {
    getCollectionSplit()
    getCollectionDaybyDay()
  }, [month,year,selectedVenueId]); 

  useEffect(() => {
    localStorage.setItem('month', JSON.stringify(month));
    localStorage.setItem('year', JSON.stringify(year));
  }, [month,year]); 

  useEffect(()=> {
    getCollectionGraph()
  },[selectedVenueId])

  const onChangeYear = (date, dateString) => {
    setYear(dateString);
  };  

  const getCollectionSplit = () => {
    setPieLoading(true)
    getData(`/business/get_collection_split_up_by_mode/?month=${month}&year=${year}&venue_id=${selectedVenueId}`)
    .then(response =>{
      setPieGraphData(response.result)
      setTotalCollection(response.total_collection)
      setTotalData(response.number_box_data)   
    })
    .catch(error => {
      console.log(error.message);
    })
     .finally(()=>{
      setPieLoading(false)
    })
  }

  const getCollectionGraph = () => {
    setGraphLoading(true)
    getData(`/business/get_collection_graph/?venue_id=${selectedVenueId}&city_id=${cityId}`)
    .then(response =>{
      setGraphData(response.result) 
      setGraphLoading(false);
    })
    .catch(error => {
      setGraphLoading(false)
      console.log(error.message);
    });
  }

  const getCollectionDaybyDay = () => {
    setLoading(true)
    var date = year + '-' + month
    getData(`/eagleeye/getTableDataJSON/?report_id=752338&venue_id=${selectedVenueId}&date=${date}`)
    .then(response =>{
      setCollectionDetails(response.data)
      setHeader(response.headers)
      setLoading(false)
    })
    .catch(error => {
      setLoading(false)
      console.log(error.message);
    });
  }

  const formatIndianCurrency = (value) => {
    return Number(value).toLocaleString('en-IN')
  };

  // const collectionColumns = header.map((item)=> (
  //   {
  //     title: item,
  //     dataIndex: item,
  //     align: 'center',
  //     render: (value) => {
  //       return isNaN(Number(value)) ? value : value.toLocaleString('en-IN')
  //     },
  //   })
  // )

  const renderHeader = (title,type) => {
    return(
      <div style={{ textAlign: 'center', fontWeight: type ? 'normal' :'bold' }}>{title}</div>
    )
  }  

  const levelNames = ['Regular','Advanced','Elite','Residential']

  const academyColumn = {
    title: renderHeader('Academy'),
    align: 'center',
    children: [
      ...levelNames.map(level => ({
        title: renderHeader(level,'normal'),
        width: 110,
        dataIndex: [level],
        align: 'center',
      })),

      {
        title: renderHeader('Total'),
        dataIndex: 'Academy',
        width: 110,
        align: 'center',
      },
    ],
  };

  const collectionColumns = [
    {
      title: renderHeader('Day'),
      dataIndex: 'Day',
      align: 'center',
      width: 300,
    },
    {
      title: renderHeader('Total'),
      dataIndex: 'Total',
      align: 'center',
      width: 100,
    },
    {
      title: renderHeader('Tickets'),
      dataIndex: 'Tickets',
      align: 'center',
      width: 100,
    },
    academyColumn,
    {
      title: renderHeader('Kit Fee'),
      dataIndex: 'Kit Fee',
      align: 'center',
      width: 110,
    },
    {
      title: renderHeader('Adults'),
      dataIndex: 'Adults',
      align: 'center',
      width: 110,
    },
    {
      title: renderHeader('Court Booking'),
      dataIndex: 'Court Booking',
      align: 'center',
      width: 110,
    },
    {
      title: renderHeader('Others'),
      dataIndex: 'Others',
      align: 'center',
      width: 110,
    },
    {
      title: '',
      width:10,
      dataIndex: 'venue',
    }
  ]

  return (
    <Styled.MainContainer>

      <Styled.TopDiv>    
        <Breadcrumb style={{padding:'10px'}} >
          <Breadcrumb.Item>
            <Link to="/">
              <HomeOutlined />
            </Link>
          </Breadcrumb.Item>

          <Breadcrumb.Item>
            <Link to="/collection">
              <BankFilled />
              <span style={{paddingLeft:'5px'}}>Collection</span>
            </Link>
          </Breadcrumb.Item>

          <Breadcrumb.Item>{venueName}</Breadcrumb.Item>
        </Breadcrumb>

        <div style={{display: 'flex'}}>
          <Styled.Selector>
            <Select
                className = 'mainSelector'
                style={{width: 150}}
                onChange={setMonth}
                value = {month}
                bordered={false}
              >
                <Option value="12"> December </Option>
                <Option value="11"> November </Option>
                <Option value="10"> October </Option>
                <Option value="09"> September </Option>
                <Option value="08"> August </Option>
                <Option value="07"> July </Option>
                <Option value="06"> June </Option>
                <Option value="05"> May </Option>
                <Option value="04"> April </Option>
                <Option value="03"> March </Option>
                <Option value="02"> February </Option>
                <Option value="01"> January </Option>
              </Select>
          </Styled.Selector>

          <Styled.Selector>
            <div className = 'mainSelector'>
              <DatePicker defaultValue={moment(year, 'YYYY')}  onChange = {onChangeYear}  bordered={false}  picker="year" />
            </div> 
          </Styled.Selector>
        </div>
      </Styled.TopDiv>

      <Styled.Header>          
        <span> Collection - {venueName}</span>
      </Styled.Header>

      <Styled.GraphContainer>

        <Styled.GraphDiv>
          <Styled.GraphDivLabelDiv>
            <Styled.LabelHeading> Collection - Analysis </Styled.LabelHeading>

            <Styled.GraphMonthSelector>
              Last 6 months
            </Styled.GraphMonthSelector>
          
          </Styled.GraphDivLabelDiv>
          {graphLoading ?
            <div style={{ height: '30vh',display: 'flex',alignItems: 'center',justifyContent: 'center' }}>
              <Spin />
            </div>
          :
            <ResponsiveContainer width="100%" height="80%">
              <LineChart
                width={500}
                height={300}
                data={graphData}
                margin={{
                  top: 5,
                  right: 30,
                  left: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis 
                  dataKey="month" 
                  tickFormatter={(value) => moment(value, "MMMM YYYY").format("MMM")}
                />
                <YAxis tickFormatter={formatIndianCurrency}/>
                <Tooltip formatter={(value, name) => [formatIndianCurrency(value), name]}/>
                <Legend />
                <Line type="monotone" dataKey="total_collection" stroke="#1e7c0a" name="Total Collection"/>
                <Line type="monotone" dataKey="academy" stroke="#c48e1a" name="Academy"/>                
                <Line type="monotone" dataKey="adults" stroke="#4345ab" name="Adults"/>
                <Line type="monotone" dataKey="court booking" stroke="#5676f5" name="Court Booking"/>
                <Line type="monotone" dataKey="others" stroke="#470053" name="Others"/>
              </LineChart>
            </ResponsiveContainer>
          }
        </Styled.GraphDiv>

        <span></span>
        
        <Styled.GraphDiv>
          <Styled.GraphDivLabelDiv>
            <Styled.LabelHeading> Payment Mode Split Up </Styled.LabelHeading>
          </Styled.GraphDivLabelDiv>

          {pieLoading ?
            <div style={{ height: '30vh',display: 'flex',alignItems: 'center',justifyContent: 'center' }}>
              <Spin />
            </div>
          :
              totalCollection > 0 ?              
                <Styled.PieDiv>
                              
                  <div style={{position: 'relative',height:'fit-content'}}>
                    <PieChart width={200} height={200}>
                      <Pie
                        data={pieGraphData}
                        innerRadius={60}
                        // outerRadius={80}
                        fill="#8884d8"
                        // paddingAngle={5}
                        dataKey="collection"
                      >
                        {pieGraphData.map((entry, index) => (
                          <Cell key={`cell-${entry}`} fill={COLORS[index % COLORS.length]} />
                        ))}
                      </Pie>
                    </PieChart>
                    <Styled.TotalAmount> {totalCollection.toLocaleString('en-IN')} </Styled.TotalAmount>
                  </div>                              
              
                  <Styled.PieDivInfo>
                    {
                      pieGraphData.map((item,index)=>(
                        <Styled.InfoRow>
                          <Styled.InfoColor style={{backgroundColor: COLORS[index % COLORS.length]}} />
                          <Styled.InfoLabel> {item.payment_mode} - {item.collection.toLocaleString('en-IN')}</Styled.InfoLabel>
                        </Styled.InfoRow>
                      ))
                    }  
                  </Styled.PieDivInfo>
              
                </Styled.PieDiv>
              :
               <Empty style={{marginTop: '10%'}} description = {<span style={{color: 'grey', fontSize: 'small'}}> data not available </span>} />
          }

        </Styled.GraphDiv>
      </Styled.GraphContainer>

      {totalData && !pieLoading &&
        <Styled.StatsDiv>
          <Styled.StatsBox>
            <Styled.StatsLabel>Month - </Styled.StatsLabel> 
            {totalData.month ? totalData.month : ''}
          </Styled.StatsBox>
          <a></a>
          <Link to={`/collections/total/?venue_id=${selectedVenueId}`}>
            <Styled.TotalBox primary={!totalData.total || totalData.total.collection == 0}>
              <span></span>
              <span style={{display:'flex'}}>
                <Styled.StatsLabel>Total Collection - </Styled.StatsLabel>
                {totalData.total && totalData.total.collection && totalData.total.collection.toLocaleString('en-IN')} 
                &nbsp;
                {totalData.total && totalData.total.tickets ? `(${totalData.total.tickets.toLocaleString('en-IN')})` : ''}
              </span>
              <ArrowRightOutlined />
            </Styled.TotalBox>
          </Link>

          <a></a> 
          <Styled.StatsBox>
            <Styled.StatsLabel>Verified - </Styled.StatsLabel> 
            {totalData.verified && totalData.verified.collection && totalData.verified.collection.toLocaleString('en-IN')}
            &nbsp;
            {totalData.verified && totalData.verified.tickets ? `(${totalData.verified.tickets.toLocaleString('en-IN')})` : ''}
          </Styled.StatsBox>
          <a></a>
          <Link to={`/collections/unverified/?venue_id=${selectedVenueId}`}>
            <Styled.UnverifiedBox primary={!totalData.unverified || totalData.unverified.collection == 0}>
              <span></span>
              <span style={{display:'flex'}}>
              <Styled.StatsLabel>Unverified - </Styled.StatsLabel> 
                {totalData.unverified && totalData.unverified.collection && totalData.unverified.collection.toLocaleString('en-IN')}
                &nbsp;
                {totalData.unverified && totalData.unverified.tickets ? `(${totalData.unverified.tickets.toLocaleString('en-IN')})` : ''}
                &nbsp;
              </span>
              <ArrowRightOutlined />
            </Styled.UnverifiedBox>
          </Link>
          <a></a>
        </Styled.StatsDiv>
      }

      {loading ?
        <Skeleton active paragraph={{ rows: 7 }} title={false} />
      :
        <Table
          className="revenue-table table_container"
          rowKey="id"
          columns={collectionColumns}
          dataSource={collectionDetails}
          pagination={false}
         />
      }

    </Styled.MainContainer>
  );
}

export default CollectionSummary;